import React, { useEffect, useState } from 'react';
import '../styles.css';
import { useNavigate } from 'react-router-dom';

const Humidity = () => {
  const [humidity, setHumidity] = useState(null);
  const [connectionStatus, setConnectionStatus] = useState('Disconnected');
  const [lastUpdate, setLastUpdate] = useState(null);
  const navigate = useNavigate();

  const CHANNEL_ID = '3018449';
  const READ_API_KEY = 'WPIXJNON8E0WC5U0';

  const getThingSpeakUrl = () => {
    const baseUrl = `https://api.thingspeak.com/channels/${CHANNEL_ID}/feeds/last.json`;
    return READ_API_KEY ? `${baseUrl}?api_key=${READ_API_KEY}` : baseUrl;
  };

  useEffect(() => {
    const fetchHumidityData = async () => {
      try {
        setConnectionStatus('Fetching...');
        const response = await fetch(getThingSpeakUrl());
        if (response.ok) {
          const data = await response.json();

          if (!data.created_at) {
            setConnectionStatus('Device Offline');
            setHumidity(null);
            setLastUpdate(null);
            return;
          }

          const lastUpdateTime = new Date(data.created_at);
          const now = new Date();
          const diffMinutes = (now - lastUpdateTime) / 1000 / 60;

          if (diffMinutes > 5) {
            setConnectionStatus('Device Offline');
            setHumidity(null);
            setLastUpdate(null);
            return;
          }

          const humidityValue = parseFloat(data.field2);
          if (!isNaN(humidityValue)) {
            setHumidity(humidityValue);
            setConnectionStatus('Connected');
            setLastUpdate(lastUpdateTime.toLocaleTimeString());
          } else {
            console.warn('Invalid humidity value:', data.field2);
            setHumidity(null);
          }
        } else {
          setConnectionStatus('Error Fetching');
        }
      } catch (error) {
        console.error('Error fetching ThingSpeak data:', error);
        setConnectionStatus('Error');
      }
    };

    fetchHumidityData();
    const interval = setInterval(fetchHumidityData, 30000);
    return () => clearInterval(interval);
  }, []);

  const getStatusIndicator = () => {
    if (typeof humidity !== 'number') return null;
    const inRange = humidity >= 40 && humidity <= 60;
    return (
      <div className={`status-indicator ${inRange ? 'good' : 'bad'}`}>
        <span className="material-icons emoji">
          {inRange ? 'sentiment_satisfied_alt' : 'sentiment_dissatisfied'}
        </span>
        <span className="label">{inRange ? 'Good' : 'Bad'}</span>
      </div>
    );
  };

  const displayHumidity =
    typeof humidity === 'number' ? `${humidity.toFixed(1)}%` : 'Loading...';

  return (
    <div className="main-content">
      <div className="humidity-container">
        <h2>Humidity 💧</h2>

        <div
          className="connection-status"
          style={{
            color: connectionStatus === 'Connected' ? '#22cf27ff' : '#f44336',
            fontSize: '14px',
            marginBottom: '10px',
          }}
        >
          <strong>ThingSpeak Status:</strong> {connectionStatus}
          {lastUpdate && (
            <span style={{ marginLeft: '15px' }}>Last Update: {lastUpdate}</span>
          )}
        </div>

        {connectionStatus === 'Device Offline' ? (
          <div
            style={{
              color: '#f44336',
              fontWeight: 'bold',
              textAlign: 'center',
              padding: '20px',
              fontSize: '16px',
            }}
          >
            ⚠️ Device Offline or No Recent Data
          </div>
        ) : humidity === 0 ? (
          <div
            style={{
              color: '#f44336',
              fontWeight: 'bold',
              textAlign: 'center',
              padding: '20px',
              fontSize: '16px',
            }}
          >
            ⚠️ Error in the sensor or sensor disconnected
          </div>
        ) : (
          <div className="status-card layout-horizontal">
            <span className="status-icon humidity-icon">💧</span>
            <div className="status-info">
              <p style={{fontSize:'18px'}}>Humidity: {displayHumidity}</p>
            </div>
            {getStatusIndicator()}
          </div>
        )}

        <h3>Humidity Ranges</h3>
        <div className="ranges">
          <div className="range-item">
            <span className="range-icon">✅</span>
            <p>Recommended: 40% to 60% relative humidity</p>
          </div>
          <div className="range-item">
            <span className="range-icon">✅</span>
            <p>Ideal: 45% to 55% relative humidity</p>
          </div>
        </div>
        {/* View Logs Button */}
        <button 
              className='ViewLogsButton' 
              onClick={() => navigate('/dashboard/data-history')}
        >
          View Logs
        </button>
      </div>
    </div>
  );
};

export default Humidity;
